import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  Avatar,
  Button,
  Card,
  Col,
  Empty,
  Form,
  Input,
  Layout,
  Row,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Empty_Location from "../../../Assets/Images/Empty/Empty_Location.svg";
import { CustIcon } from "../../../Components/Svgs";

import { ProfileAvatar } from "../../../Components/Avatar";
import { AddLocationDrawer } from "../../../Components/Drawers/AddLocation";
import { getAddress } from "../../../Components/Helper";
import { Loader } from "../../../Components/Loader";
import { GET_JOB_ROLES_BY_ID } from "../../../Graphql/queries";
import {
  GET_LOCATION_LIST,
  GET_USER_SUBSCRIPTION,
} from "../../../Graphql/subscriptions";
import "./Location.less";
import { ResumePlanModal } from "../../../Components/Modals/ResumePlanModal";

const { Content } = Layout;
export const LocationList = (props) => {
  const [showAddNewLocationDrawer, setShowAddNewLocationDrawer] =
    useState(false);
  const user_id = localStorage.getItem("user_id");
  const type_id = "1";
  const working_day = moment().format("dddd");
  const history = useHistory();

  const { data: subscriptionData, loading: subscriptionDataLoading } =
    useSubscription(GET_USER_SUBSCRIPTION, {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    });

  const [fetchParams, setFetchParams] = useState({
    user_id,
    type_id,
    working_day,
  });
  const { data, loading } = useSubscription(GET_LOCATION_LIST, {
    fetchPolicy: "cache-and-network",
    variables: fetchParams,
    shouldResubscribe: true,
  });

  const { data: userRoleData, loading: userRoleDataloading } = useQuery(
    GET_JOB_ROLES_BY_ID,
    {
      variables: { user_id: user_id },
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const editLocation = (id) => {
    history.push("/location/" + id + "/edit");
  };
  const onFinish = (values) => {
    values.location_name = values.location_name
      ? "%" + values.location_name + "%"
      : null;
    values.city = values.city ? "%" + values.city + "%" : null;
    values.state = values.state ? "%" + values.state + "%" : null;
    values.country = values.country ? "%" + values.country + "%" : null;
    values.zipcode = values.zipcode ? "%" + values.zipcode + "%" : null;
    const filter = {
      user_id,
      type_id,
      working_day,
      ...values,
    };
    setFetchParams(filter);
  };

  console.log("subscriptionData :>> ", subscriptionData);

  return (
    <Content className="site-body-layout">
      <section className="loationFilter pt-3">
        <Form
          // form=""
          name="horizontal_login"
          // layout="inline"
          onFinish={onFinish}
        >
          <Row gutter={16}>
            <Col xl={5} lg={8} md={8} sm={8} xs={24}>
              <Tooltip
                trigger={["focus"]}
                title="Location"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="location_name">
                  <Input placeholder="Location" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xl={5} lg={8} md={8} sm={8} xs={24}>
              <Tooltip
                trigger={["focus"]}
                title="City"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="city">
                  <Input placeholder="City" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xl={4} lg={8} md={8} sm={8} xs={24}>
              <Tooltip
                trigger={["focus"]}
                title="State"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="state">
                  <Input placeholder="State" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xl={3} lg={8} md={8} sm={8} xs={24}>
              <Tooltip
                trigger={["focus"]}
                title="Zip code"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="zipcode">
                  <Input placeholder="Zip code" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xl={4} lg={8} md={8} sm={8} xs={24}>
              <Tooltip
                trigger={["focus"]}
                title="Country"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="country">
                  <Input placeholder="Country" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xl={3} lg={8} md={8} sm={8} xs={24}>
              {" "}
              <Form.Item shouldUpdate className="">
                {() => (
                  <Button
                    type="primary"
                    htmlType="submit"
                    shape="round"
                    size="large"
                    className="w-100"
                    // disabled={
                    //   !form.isFieldsTouched(true) ||
                    //   !!form.getFieldsError().filter(({ errors }) => errors.length)
                    //     .length
                    // }
                  >
                    Search
                  </Button>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </section>

      <section className="loationList">
        <Row gutter={16}>
          {!userRoleDataloading &&
          userRoleData.job_roles[0]?.access_type === "owner" ? (
            <Col
              xl={8}
              lg={8}
              md={12}
              xs={24}
              className="locationsColList py-2"
              key={0}
            >
              <Card
                key={0}
                className="locationsCardAdd"
                onClick={() => setShowAddNewLocationDrawer((c) => !c)}
              >
                <ul>
                  <h2 className="titleIcon">
                    <CustIcon type="plus-thin" className="mr-2" />
                  </h2>
                  <h3 className="locationNew">Add New Location</h3>
                </ul>
              </Card>
            </Col>
          ) : (
            <></>
          )}
          {loading || userRoleDataloading ? (
            <Loader />
          ) : data ? (
            data.getUserLocationMaps.map((lData, index) => {
              return (
                <Col
                  xl={8}
                  lg={8}
                  md={12}
                  xs={24}
                  className="locationsColList py-2"
                  key={index}
                >
                  <Card
                    key={index}
                    className="locationsCard"
                    onClick={(e) =>
                      editLocation(lData.locationDetails.location_id)
                    }
                  >
                    <h4 className="title">
                      {lData.locationDetails.location_name}
                    </h4>
                    <div className="location">
                      {getAddress(lData.locationDetails)}
                    </div>
                    <Row className="mt-auto">
                      <Col md={12} xs={24}>
                        <div className="locLabel">Employees</div>
                        <div className="empList">
                          <Avatar.Group
                            maxCount={4}
                            size="2.142857142857143rem"
                          >
                            {lData.locationDetails.user_location_maps.map(
                              (uData, uIndex) => {
                                return (
                                  <ProfileAvatar
                                    name={
                                      uData.userDetails.first_name +
                                      " " +
                                      uData.userDetails.last_name
                                    }
                                    key={uIndex}
                                  />
                                );
                              }
                            )}
                          </Avatar.Group>
                        </div>
                      </Col>
                      <Col md={12} xs={24}>
                        <div className="locLabel">Working hours</div>
                        <div className="WorkingHours pt-2">
                          {lData.locationDetails.location_timings.length > 0
                            ? moment(
                                lData.locationDetails.location_timings[0]
                                  .opening_time,
                                "hh:mm"
                              ).format("LT") +
                              " - " +
                              moment(
                                lData.locationDetails.location_timings[0]
                                  .closing_time,
                                "hh:mm"
                              ).format("LT")
                            : "Weekly Off"}
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              );
            })
          ) : (
            <Empty
              image={Empty_Location}
              description={<span>No locations added!</span>}
            />
          )}
        </Row>
      </section>
      {showAddNewLocationDrawer &&
        (subscriptionData?.user_subscription[0]?.subscriptionStatus?.status.toString() ===
        "cancel_applied" ? (
          <ResumePlanModal
            showAddNewLocationDrawer={showAddNewLocationDrawer}
            setShowAddNewLocationDrawer={setShowAddNewLocationDrawer}
          />
        ) : (
          <AddLocationDrawer
            visible={showAddNewLocationDrawer}
            toggleDrawer={() => setShowAddNewLocationDrawer((c) => !c)}
          />
        ))}
    </Content>
  );
};
